var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "price_lists") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_file-invoice-dollar-solid",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    id: "file-invoice-dollar-solid",
    d: "M2.333,0A2.3,2.3,0,0,0,0,2.25v13.5A2.3,2.3,0,0,0,2.333,18h9.333A2.3,2.3,0,0,0,14,15.75V5.625H9.333A1.145,1.145,0,0,1,8.167,4.5V0Zm7,0V4.5H14Zm-7,2.813a.575.575,0,0,1,.583-.562H5.25a.563.563,0,1,1,0,1.125H2.917A.575.575,0,0,1,2.333,2.813Zm0,2.25A.575.575,0,0,1,2.917,4.5H5.25a.563.563,0,1,1,0,1.125H2.917A.575.575,0,0,1,2.333,5.063ZM7,7.594a.575.575,0,0,1,.583.563v.608a7.536,7.536,0,0,1,.879.179.56.56,0,0,1,.412.689.583.583,0,0,1-.715.4,4.942,4.942,0,0,0-1.17-.186,1.777,1.777,0,0,0-.86.193.489.489,0,0,0-.3.45c0,.13.047.229.266.355a5.243,5.243,0,0,0,1.065.383l.018,0h0a5.528,5.528,0,0,1,1.323.513,1.566,1.566,0,0,1,.828,1.343A1.634,1.634,0,0,1,8.5,14.548a2.6,2.6,0,0,1-.915.32v.6a.584.584,0,0,1-1.167,0v-.626A8.025,8.025,0,0,1,5.29,14.53h0l-.226-.074a.557.557,0,0,1-.368-.71.59.59,0,0,1,.736-.355c.091.028.175.056.259.084h0a4.68,4.68,0,0,0,1.323.306,1.655,1.655,0,0,0,.864-.186.519.519,0,0,0,.284-.492c0-.162-.066-.274-.281-.408A4.71,4.71,0,0,0,6.825,12.3l-.058-.018h0A5.685,5.685,0,0,1,5.5,11.8a1.494,1.494,0,0,1-.828-1.311,1.6,1.6,0,0,1,.868-1.424,2.745,2.745,0,0,1,.879-.306v-.6A.575.575,0,0,1,7,7.594Z",
    transform: "translate(1436 16)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceLists);
export default __webpack_public_path__ + "static/media/price_lists.29a2fb00112dd24a36a3741d66f61ada.svg";
export { ForwardRef as ReactComponent };